import call from "@/conn-global/api";

export default {
  // getDataApi: ({ commit }) => {
  //   call
  //     .get("https://api.coindesk.com/v1/bpi/currentprice.json")
  //     .then((res) => {
  //       if (res != undefined) {
  //         commit("addDataApi", res.data);
  //       }
  //     })
  //     .catch((err) => {
  //       alert(err);
  //     });
  // },

  getIdUser: ({ commit }) => {
    let response = call.get("/v1/dashboard/get_dashboard").then((res) => {
      // console.log(res.data);
      if (res !== undefined) {
        commit("addNamaUser", res.data.data.customer_global.nama_awal);
        return res.data;
      }
    });
    return response;
  },

  getDataAkun: ({ commit }, idUser) => {
    call
      .get("/v1/dashboard/customer_global/" + idUser)
      .then((res) => {
        if (res !== undefined) {
          commit("addDataAkun", res.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  // postDataLogin: ({ commit }) => {
  //   let data = {
  //     country_code: "62",
  //     telp: "85159722546",
  //     password: "ilham",
  //   };
  //   call
  //     .post("https://dev-central-kube.smartlink.id/scan/v1/auth/login", data)
  //     .then((res) => {
  //       if (res != undefined) {
  //         commit("addDataLogin", res.data);
  //         alert(res.status);
  //       }
  //     })
  //     .catch((err) => {
  //       alert(err);
  //     });
  // },
  postChangeName: async ({ commit }, data) => {
    let response = await call
      .post("/v1/akun/update_nama", data)
      .then((res) => {
        commit("addDataAkun", res.data);
        return res.data;
      })
      .catch((err) => {
        console.log(err);
      });
    return response;
  },

  getDataDashboard: async ({ commit }) => {
    await call
      .get("/v1/dashboard/get_dashboard", true)
      .then((res) => {
        if (res != undefined) {
          commit("dataAkun", res.data.data);
        }
      })
      .catch((err) => {
        alert(err);
      });
  },

  postOtp: async () => {
    let response = await call
      .post("/v1/akun/request_otp_password")
      .then((res) => {
        return res.data;
      });
    return response;
  },

  postUpdatePassword: async ({ commit }, data) => {
    // console.log(data);
    let response = await call
      .post("/v1/akun/update_password", data)
      .then((res) => {
        if (res !== undefined) {
          commit("dataPost", res.data);
          return res;
        }
        return res.data;
      })
      .catch((err) => {
        // console.log(err.response);
        return err.response;
      });
    return response;
  },
};
